$(document).ready(function () {
    $('#connection-types-table').DataTable({
        dom: 'fBlrtip',
        language: {
            url: '/data_tables_translation.json'
        }
    });
});
